import React from 'react'

const FormDown = () => {
    return (
        <div className="user-form pt-6">
            <h1 className="title is-3">Welcome to the Site Check Submission Form</h1>
            <p>As of COB on 10/10/2023, this survey is closed for processing.</p>
            <p className="mb-6">Thank you for your interest.</p>
            <p>
                <strong>The California Governor's Office of Planning and Research</strong>
                <br />
                <em>with support from The Conservation Biology Institute</em>
            </p>
        </div>
    )
}

export default FormDown
